import { render } from "./Picture.vue?vue&type=template&id=5591922b"
import script from "./Picture.vue?vue&type=script&lang=js"
export * from "./Picture.vue?vue&type=script&lang=js"

import "./Picture.vue?vue&type=style&index=0&id=5591922b&lang=less"
script.render = render

export default script